import { Activity, Ear } from "lucide-react";
import { SectionHeading } from "./Section";
import { Reveal, Stagger, StaggerItem } from "./Reveal";
import { CONDITIONS } from "../data/site";

const Column = ({ title, icon: Icon, items, accent }) => (
  <div className="rounded-[2rem] border border-dash-line bg-white p-8 md:p-10 shadow-[0_10px_40px_rgb(10,37,64,0.04)]">
    <div className="flex items-center gap-3">
      <span className={`flex h-12 w-12 items-center justify-center rounded-2xl ${accent === "teal" ? "bg-dash-teal/10 text-dash-teal" : "bg-dash-indigo/10 text-dash-indigo"}`}>
        <Icon className="h-6 w-6" />
      </span>
      <h3 className="font-display text-2xl font-bold text-dash-ink">{title}</h3>
    </div>
    <Stagger className="mt-6 flex flex-wrap gap-2.5">
      {items.map((c) => (
        <StaggerItem key={c}>
          <span className={`inline-block rounded-full border px-4 py-2 text-sm font-medium transition-colors duration-300 ${accent === "teal" ? "border-dash-teal/25 bg-dash-teal/5 text-dash-ink hover:bg-dash-teal hover:text-white" : "border-dash-indigo/25 bg-dash-indigo/5 text-dash-ink hover:bg-dash-indigo hover:text-white"}`}>
            {c}
          </span>
        </StaggerItem>
      ))}
    </Stagger>
  </div>
);

export const ConditionsSection = ({ compact = false }) => (
  <section className="py-24 md:py-32 bg-dash-bg" data-testid="conditions-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading center overline="Conditions We Support" title="Conditions We Support" subtitle="We provide assessment, management and rehabilitation for a wide range of physiotherapy, speech and hearing concerns." />
      <div className="mt-14 grid gap-6 lg:grid-cols-2">
        <Reveal><Column title="Physiotherapy" icon={Activity} items={CONDITIONS.physio} accent="teal" /></Reveal>
        <Reveal delay={0.1}><Column title="Speech & Hearing" icon={Ear} items={CONDITIONS.speech} accent="indigo" /></Reveal>
      </div>
      <Reveal delay={0.15}>
        <p className="mt-8 text-center text-sm text-dash-muted max-w-2xl mx-auto">
          Our focus is on support, assessment, management and rehabilitation. We do not promise cures or guaranteed outcomes — care is always personalized to your individual needs.
        </p>
      </Reveal>
    </div>
  </section>
);
